import * as types from '../types/ui';

// -------- Toggle --------

export const toggle = (payload) => ({
	type: types.TOGGLE,
	payload,
});
